export enum SyncProductId {
    Flex = "flex",
    FlexInsights = "flex_insights"
}
